const useCurrentStepInfo = (vehicleData, tabValue) => {
  let passedSteps = 0,
    currentProgress = 0,
    isCurrentStep = false

  const vehicleDataSides = Object.values(vehicleData)

  vehicleDataSides.forEach((side, index) => {
    if (side.photo) {
      if (index !== tabValue) {
        isCurrentStep = true
      }
      // If photo is exist then this step is passed;
      currentProgress += 25
      passedSteps++
    }
  })

  return {
    currentProgress,
    isCurrentStep,
    isLastStep: passedSteps > vehicleDataSides.length - 1,
  }
}

export default useCurrentStepInfo
